<template>
    <div class="w-full space-y-3">
        <Head title="Projects"/>
        <div class="flex justify-between">
            <h1 class="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl"><span v-if="archived === true">Archived </span>Projects</h1>
        </div>
        <div class="w-full flex gap-3 justify-between">
            <div class="flex gap-3 w-full">
                <Link :href="route('frontend.project.create')"
                      class="inline-flex items-center px-4 py-2 border border-transparent rounded-md font-semibold text-xs text-white uppercase bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    <svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                         stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    Add New Project
                </Link>
                <Link v-if="archived === false" :href="route('frontend.project.archived')"
                    class="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
                    <svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                         stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    View Archived Projects
                </Link>
                <Link v-else :href="route('frontend.project.index')"
                      class="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
                    <svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                         stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    View Projects
                </Link>
            </div>
            <div class="w-full flex justify-end justify-content-end align-items-end">

            <search-filter :show-filter="false" v-model:value="form.search" class="w-1/2 max-w-md mr-4"
                           @reset="reset"></search-filter>
                </div>
        </div>
        <div class="w-full flex gap-3 justify-between">
            <div class="flex gap-1 w-full items-center">
                <select id="project_status" v-model="form.filter.status"
                        :class="{'border-red-500': form.errors['filter.status']}"
                        class="mt-1 block w-2/3 bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                    <option value selected v-html="'Status'"></option>
                    <option v-for="status in filters.statuses" :value="status"
                            v-html="status.charAt(0).toUpperCase() + status.substring(1)"></option>
                </select>

                <select id="project_status" v-model="form.filter.client"
                        class="mt-1 block w-2/3 bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                    <option value selected v-html="'Client'"></option>
                    <option v-for="client in filters.clients" :value="client.id"
                            v-html="client.name"></option>
                </select>
                <select id="project_status" v-model="form.filter.office"
                        class="mt-1 block w-2/3 bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                    <option value selected v-html="'Office'"></option>
                    <option v-for="office in filters.offices" :value="office.id"
                            v-html="office.name"></option>
                </select>
                <select id="project_status" v-model="form.filter.manager"
                        class="mt-1 block w-2/3 bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                    <option value selected v-html="'Project Manager'"></option>
                    <option v-for="manager in filters.managers" :value="manager.id"
                            v-html="manager.first_name + ' ' + manager.last_name"></option>
                </select>
                <div class="flex items-center gap-2 w-full">
                <input v-model="form.filter.starts_at" type="date"
                       name="starts_at" id="starts_at"
                       autocomplete="starts_at"
                       class="flex-grow-1 mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm"/>
                </div>
                <div class="flex items-center gap-2 w-full">
                <input v-model="form.filter.ends_at" type="date"
                       name="ends_at" id="ends_at"
                       autocomplete="ends_at"
                       class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm"/>
                </div>
                <select id="project_status" v-model="form.filter.sort_by"
                        class="mt-1 block w-2/3 bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                    <option value selected v-html="'Sort by'"></option>
                    <option v-for="(sortby,index) in filters.sortby" :value="index"
                            v-html="sortby"></option>
                </select>
                <select id="project_status" v-model="form.filter.direction"
                        class="mt-1 block w-1/2 bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                    <option value selected v-html="'Direction'"></option>
                    <option value="asc" v-html="'Asc'"></option>
                    <option value="desc" v-html="'Desc'"></option>
                </select>

            </div>

        </div>

        <div class="bg-white py-6 px-4 sm:p-6 shadow mb-6">
            <div class="flex flex-col mt-3 space-y-3">
                <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                        <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                            <table class="min-w-full divide-y divide-gray-200">
                                <thead class="bg-gray-50">
                                <tr>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Reference
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Name
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Client
                                    </th>

                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Office
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Project Manager
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Date
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Status
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-if="projects.data.length > 0" v-for="(project,index) in projects.data"
                                    :key="index"
                                    :class="{'bg-gray-100': index % 2, 'bg-red-100 hover:bg-red-50': project.overdue === true && project.status !== 'Confirmed'}" class="hover:bg-gray-50 cursor-pointer">
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a :href="route('frontend.project.show' , project.id)">{{ project.reference }}</a>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a :href="route('frontend.project.show' , project.id)">
                                            {{ project.title }}
                                        </a>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ project.client }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ project.office }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ project.project_manager }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <span v-if="project.starts_at !== null">{{ moment(project.starts_at, 'YYYY-MM-DD').format('DD-MM-YYYY') }}</span> <span v-if="project.ends_at !== null"> - {{ moment(project.ends_at, 'YYYY-MM-DD').format('DD-MM-YYYY')}}</span>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <span v-if="project.status === 'Request'"
                                              class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-gray-500 text-white"> {{
                                                project.status
                                            }} </span>
                                        <span v-if="project.status === 'Cost'"
                                              class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-yellow-100 text-yellow-800"> {{
                                                project.status
                                            }} </span>
                                        <span v-if="project.status === 'Cancelled'"
                                              class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-red-100 text-red-800"> {{
                                                project.status
                                            }} </span>
                                        <span v-if="project.status === 'Confirmed'"
                                              class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-blue-100 text-white-800"> {{
                                                project.status
                                            }} </span>
                                        <span v-if="project.status === 'Complete'"
                                              class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-green-100 text-green-800"> {{
                                                project.status
                                            }} </span>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 flex">
                                      <!-- Not an inertia link, this is to specifically cause a full page load when visiting a project -->
                                        <Link :href="route('frontend.project.show' , project.id)">
                                            <PencilAltIcon class="w-5 h-5 text-light-pitch-purple"></PencilAltIcon>
                                        </Link>
                                        <Link v-if="archived === true" :href="route('frontend.project.unarchive' , project.id)">
                                            <RefreshIcon class="w-5 h-5 text-light-pitch-purple"></RefreshIcon>
                                        </Link>
                                    </td>
                                </tr>
                                <tr v-else>
                                    <td colspan="8"
                                        class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        There are no projects available for your search criteria.
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <Pagination :links="projects.links"/>
            </div>
        </div>
    </div>
</template>

<script>
import Authenticated from "@/Layouts/Authenticated.vue";
import SearchFilter from "@/Components/SearchFilter.vue";
import debounce from "lodash/debounce";
import pickBy from "lodash/pickBy";
import {Link, Head, useForm} from "@inertiajs/vue3";
import mapValues from "lodash/mapValues";
import {PencilAltIcon, RefreshIcon} from "@heroicons/vue/outline";
import moment from "moment/moment";
import Pagination from "@/Components/Pagination.vue";

export default {
    layout: Authenticated,
    components: {
        SearchFilter,
        Link,
        PencilAltIcon,
        Head,
        RefreshIcon,
        Pagination
    },
    props: {
        projects: Object,
        filters: Object,
        archived: Boolean,
    },
    created() {
      this.moment = moment;
    },
    data() {
        return {
            form: useForm({
                search: null,
                filter: {
                    status: "",
                    manager: "",
                    client: "",
                    project_type: "",
                    starts_at: "",
                    office: "",
                    ends_at: "",
                    sort_by: "created_at",
                    direction: "desc"
                }
            })
        }
    },
    methods: {
        reset() {
            this.form.reset();
        },
    },
    watch: {
        form: {
            deep: true,
            handler: debounce(function () {
                if(this.archived === true) {
                    this.$inertia.get(route('frontend.project.archived'), pickBy(this.form), {
                        preserveState: true,
                        preserveScroll: true
                    })
                } else {
                    this.$inertia.get(route('frontend.project.index'), pickBy(this.form), {
                        preserveState: true,
                        preserveScroll: true
                    })
                }
            }, 500),
        },
    },
}
</script>
